import { Directive, TemplateRef } from "@angular/core";

@Directive({
    selector: "[appSelected]",
    standalone: false
})
export class SelectedDirective {
  public constructor(public templateRef: TemplateRef<unknown>) {}
}
